import { ColumnDef } from "@tanstack/react-table";
import { Fragment, ReactNode } from "react";
import { IntegratorsLabel, Shop } from "@/types/v2";
import { HeaderSortable } from "@/components/Base/HeaderSortable";
import { firestoreToDateTime } from "@/lib/utils";
export type DatatableShop = Shop;

interface ColumnProps {
  actions: (user: DatatableShop) => ReactNode[];
}

const createActionsColumn = ({
  actions,
}: ColumnProps): ColumnDef<DatatableShop> => ({
  accessorKey: "actions",
  header: "",
  cell: ({ row }) => {
    const item = row.original;
    return (
      <div className="flex gap-2">
        {actions(item).map((action, index) => (
          <Fragment key={`action-${item.id}-${index}`}>{action}</Fragment>
        ))}
      </div>
    );
  },
});

const shopColumns = (props?: ColumnProps) => {
  const col: ColumnDef<DatatableShop>[] = [
    {
      accessorKey: "id",
      header: "ID",
    },
    {
      accessorKey: "name",
      header: ({ column }) => (
        <HeaderSortable column={column} title={"Shop Name"} />
      ),
    },
    {
      accessorKey: "disabled",
      header: ({ column }) => (
        <HeaderSortable column={column} title={"Disabled"} />
      ),
      cell: ({ row }) => {
        const item = row.original;
        return <div className="text-sm">{item.disabled ? "Yes" : "No"}</div>;
      },
    },
    {
      accessorKey: "shopId",
      header: ({ column }) => (
        <HeaderSortable column={column} title={"Shop ID"} />
      ),
    },
    {
      accessorKey: "tenantId",
      header: ({ column }) => (
        <HeaderSortable column={column} title={"Tenant ID"} />
      ),
    },
    {
      accessorKey: "integration",
      header: ({ column }) => (
        <HeaderSortable column={column} title={"Integration"} />
      ),
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div className="text-sm">
            {item.integration ? IntegratorsLabel[item.integration] : "None"}
          </div>
        );
      },
    },
    {
      accessorKey: "createdAt",
      header: ({ column }) => (
        <HeaderSortable column={column} title={"Created At"} />
      ),
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div className="text-sm">
            {firestoreToDateTime(item.createdOn)?.toLocaleString()}
          </div>
        );
      },
    },
  ];

  if (props) {
    col.push(createActionsColumn(props));
  }
  return col;
};

export { shopColumns };
